import React from 'react';
import { HowToMake } from '../components/home/HowToMake';

export function HowToMakePage() {
  return <HowToMake />;
}
